export const aadharConsentText = `
I hereby confirm that I have voluntarily submitted the copy of my Aadhaar card/e-Aadhaar/masked Aadhaar/Aadhaar XML to YES Bank Limited.
I further give my consent to YES Bank to use my Aadhaar number and/or other information contained in the Aadhaar card (“Aadhaar Information”) to establish my identity for availing banking services.
I have no objection for YES Bank to conduct offline verification of my Aadhaar Information or to share the same with UIDAI for facilitating Aadhaar based authentication and to obtain my demographic information.
I have been informed by YES Bank about other alternative options available for me to establish my identity.
`;

const YBL_KYC_STATIC_DATA = 'YblMinKyc/YBL_KYC_STATIC_DATA';
const AADHAR = 'aadhaar';

export {
  YBL_KYC_STATIC_DATA,
  AADHAR,
};



// WEBPACK FOOTER //
// client/containers/YblMinKyc/constants.js